import { render, staticRenderFns } from "./material.vue?vue&type=template&id=55b53489"
import script from "./material.vue?vue&type=script&lang=js"
export * from "./material.vue?vue&type=script&lang=js"
import style0 from "./material.vue?vue&type=style&index=0&id=55b53489&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports